import React, { ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FeatureFlagsContext } from '../../hooks/useFeatureFlags';
import URLParamFeatureFlagService from './UrlParamFeatureFlagService';
import ConvertFeatureFlagService from './ConvertFeatureFlagService';
import { FeatureFlag, featureFlagDefaults } from './flags';
import type { ConvertClientData, FeatureFlagService, FeatureFlags } from './types';
import { isLiteMode } from 'src/utils/liteMode';
interface FeatureFlagsProviderProps {
  children: ReactNode;
}

const getCurrentFeatureFlags = (services: FeatureFlagService[]): FeatureFlags => {
  const newFeatureFlags: FeatureFlags = featureFlagDefaults;

  services.forEach((service) => {
    Object.keys(newFeatureFlags).forEach((flag) => {
      const newFlag = service.getFeatureFlagValue(flag as FeatureFlag);
      if (newFlag === null) return; // Only apply if we have a non-null value
      newFeatureFlags[flag as FeatureFlag] = newFlag;
    });
  });
  return newFeatureFlags;
};

export const FeatureFlagsProvider: React.FC<FeatureFlagsProviderProps> = ({
  children,
}) => {
  const location = useLocation();
  const [convertState, setConvertState] = useState<ConvertClientData>(
    {} as ConvertClientData,
  );
  const [featureFlags, setFeatureFlags] = useState<FeatureFlags>(featureFlagDefaults);

  useEffect(() => {
    // Push an event into convert queue to get the current data when available
    window._conv_q = window._conv_q || [];
    window._conv_q.push([() => setConvertState(window.convert.currentData)]);
  }, []);

  useEffect(() => {
    const featureFlagServices = [] as FeatureFlagService[];
    if (!isLiteMode) {
      featureFlagServices.push(new ConvertFeatureFlagService(convertState));
    }
    featureFlagServices.push(
      new URLParamFeatureFlagService(new URLSearchParams(location.search)),
    );

    const newFeatureFlags = getCurrentFeatureFlags(featureFlagServices);
    const mergedFeatureFlags = { ...featureFlagDefaults, ...newFeatureFlags };
    console.debug('Current feature flags', mergedFeatureFlags);
    setFeatureFlags(mergedFeatureFlags);
  }, [convertState, location.search]);

  return (
    <FeatureFlagsContext.Provider value={featureFlags}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};
